export enum ClientServiceStatusIdEnum {
  Active = 2,
  Suspended = 6,
}
